<template>
  <v-list-item
    @click="$emit('click', $event)"
    @contextmenu="$emit('more', $event)"
  >
    <v-list-item-avatar size="28" :color="avatarColor">
      <span
        class="text-body-2 font-weight-bold h-open-order-avatar"
        :class="avatarTextColor"
        v-text="order.guests"
      />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title v-text="order.tableName" />
      <v-list-item-subtitle :class="waiterClass" v-text="waiterText" />
    </v-list-item-content>
    <v-list-item-icon>
      <v-icon v-if="order.table_id !== null" v-text="icons.table" />
    </v-list-item-icon>
  </v-list-item>
</template>

<script>
  import OrderStatus from '@/Models/Static/OrderStatus'
  import Userable from '@/Mixins/Userable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Userable,
      UsesIcons,
    ],

    props: {
      order: {
        required: true,
        type: Object,
      },
    },

    data: () => ({
      OrderStatus,
    }),

    computed: {
      avatarColor () {
        // Avoid using strict equality comparisions (or switch statement)
        // because the server may return an stringified number.
        if (this.order.status == this.OrderStatus.NORMAL) {
          return 'warning'
        }
        if (this.order.status == this.OrderStatus.CHECK_PRINTED) {
          return 'primary'
        }
        return 'grey lighten-2'
      },
      avatarTextColor () {
        // Avoid using strict equality comparisions (or switch statement)
        // because the server may return an stringified number.
        return this.order.status == this.OrderStatus.CHECK_PRINTED
          ? 'white--text'
          : 'black--text'
      },
      waiterClass () {
        return this.order.tenantUser_id == this.user.id ? 'warning--text font-weight-medium' : ''
      },
      waiterText () {
        return this.$store.getters['rummage/waiter'](this.order.tenantUser_id)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-open-order-avatar {
    width: 28px;
  }
</style>
